import {
  AssignModel,
  createClient,
  IdPathParameters,
  OwnerResponse,
  postRequestFactory,
  SaveOperation,
  SearchOperation,
  searchRequestFactory
} from '@infuse/api/common';

const client = createClient('/rest/operator-api/pools');

export const locationAccessManagementPermissions = {
  ASSIGN: 'cpms.assign-pool',
  UNASSIGN: 'cpms.unassign-pool',
  SEARCH_OWNERS: 'cpms.search-pool-owners'
};

export type AssignLocationRequest = AssignModel;
export type UnassignLocationRequest = AssignModel;

export const assignLocation: SaveOperation<AssignLocationRequest, void, string> = postRequestFactory<
  AssignLocationRequest,
  void
>(client, {
  pattern: '/{id}/assign',
  permissionId: locationAccessManagementPermissions.ASSIGN
});

export const unassignLocation: SaveOperation<UnassignLocationRequest, void, string> = postRequestFactory<
  UnassignLocationRequest,
  void
>(client, {
  pattern: '/{id}/unassign',
  permissionId: locationAccessManagementPermissions.UNASSIGN
});

export const getLocationOwners: SearchOperation<OwnerResponse, IdPathParameters<string>> = searchRequestFactory<
  OwnerResponse,
  IdPathParameters<string>
>(client, {
  pattern: '/{id}/owners',
  permissionId: locationAccessManagementPermissions.SEARCH_OWNERS
});
